import { connect } from 'react-redux';
import * as R from 'ramda';
import LastStep1 from './LastStep1';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  inventoryOwners: getStoreValueByProp(['inventoryOwners']),
  loading: getStoreValueByProp(['inventoryOwnersLoading']),
});

export default connect(mapState, {})(LastStep1);
